'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactBootstrap = require('react-bootstrap');

var _components = require('components');

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _address = require('redux/modules/address');

var addressActions = _interopRequireWildcard(_address);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _filter = require('redux/modules/filter');

var filterActions = _interopRequireWildcard(_filter);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _lodash = require('lodash');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _lib = require('../../helpers/lib');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var seoInfos = {
  'cham-soc-da-massage': {
    title: 'Địa điểm chăm sóc da và massage tốt nhất',
    description: 'Địa điểm chăm sóc da và massage tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm trị mụn, trị sẹo thâm, nám, giúp trẻ hóa da, làm sạch và thanh tẩy. Địa điểm triệt lông, tắm trắng. Địa điểm massage mặt, massage body. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'lam-toc-mong': {
    title: 'Địa điểm làm tóc và làm móng tốt nhất',
    description: 'Địa điểm làm tóc, làm móng tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm làm tóc, làm móng. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'tham-my-vien': {
    title: 'Địa điểm thẩm mỹ viện tốt nhất',
    description: 'Địa điểm thẩm mỹ viện tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm thẩm mỹ viện làm mắt, mũi, mặt, ngực, bụng, miệng và giảm cân. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'phong-kham': {
    title: 'Địa điểm phòng khám tốt nhất',
    description: 'Địa điểm phòng khám tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm phòng khám da, phòng khám răng. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'the-duc-the-thao': {
    title: 'Địa điểm tập thể dục thể thao gym tốt nhất',
    description: 'Địa điểm tập thể dục thể thao tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm tập thể dục thể thao, tập yoga, tập gym, học nhảy dance, địa điểm hồ bơi. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  },
  'xam-hinh': {
    title: 'Địa điểm xăm hình tốt nhất',
    description: 'Địa điểm xăm hình tốt nhất cùng hàng ngàn review, bình luận, và hình ảnh. Tìm kiếm chi tiết địa điểm xăm hình theo quận huyện thành phố. Đặt lịch hẹn trước để tích điểm tại Lookme.vn'
  }
};
var Discover = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    if (!(0, _shops.isProminentLoaded)(getState())) {
      promises.push(dispatch((0, _shops.getProminent)()));
    }
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    addressFilter: state.address.addressFilter,
    categories: state.setup.categories,
    categoriesFilter: state.setup.categoriesFilter,
    districts: state.address.districts,
    loaded: state.filter.loaded,
    loading: state.filter.loading,
    locationUser: state.user.coords,
    pageSize: state.filter.pageSize,
    province: state.address.province,
    query: state.filter.query,
    shops: state.filter.data,
    sort: state.filter.sort,
    subCatFilter: state.setup.subCatFilter,
    total: state.filter.total
  };
}, (0, _extends3.default)({}, shopActions, filterActions, addressActions, setupActions)), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Discover, _Component);

  function Discover() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Discover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Discover.__proto__ || (0, _getPrototypeOf2.default)(Discover)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      collapse: (0, _lib.initCollapse)(_this.props.categories),
      addressFilter: _this.props.addressFilter,
      subCatFilter: _this.props.subCatFilter,
      categoriesFilter: _this.props.categoriesFilter,
      pageSize: 12,
      lazy: false,
      cat: 'cham-soc-da-massage'
    }, _this.onScroll = function (event) {
      event.preventDefault();
      if (!_this.state.lazy) {
        var wrappedElement = document.getElementById('bodyContent');
        if (_this.state.pageSize < _this.props.total && _this.isBottom(wrappedElement)) {
          _this.setState({ lazy: true });
          var filter = (0, _lib.processQuery)(_this.state.query, _this.props.province, _this.props.addressFilter, _this.props.categoriesFilter, _this.props.subCatFilter, _this.props.sort, _this.props.locationUser);
          filter.pageSize = _this.state.pageSize + 9;
          _this.props.getSearchResult(filter);
        }
      }
    }, _this.handleChangeMainCat = function (event) {
      var code = String(event.target.name);
      var categoriesFilter = _this.state.categoriesFilter;
      var subCatFilter = (0, _lodash.clone)(_this.state.subCatFilter);
      if (categoriesFilter[code] === 'none') {
        categoriesFilter[code] = 'all';
        for (var index = 0; index < _this.props.categories.length; index++) {
          if (_this.props.categories[index].code === code) {
            var childrens = _this.props.categories[index].childrens;
            for (var jndex = 0; jndex < childrens.length; jndex++) {
              subCatFilter[code] = (0, _lodash.union)(subCatFilter[code], [String(childrens[jndex].code)]);
            }
          }
        }
      } else {
        categoriesFilter[code] = 'none';
        subCatFilter[code] = [];
      }
      _this.props.handleMainCat(categoriesFilter, subCatFilter);
    }, _this.handleChangeSubCat = function (event) {
      var code = String(event.target.name);
      var parentCode = code.slice(0, -1);
      var subCatFilter = (0, _lodash.clone)(_this.state.subCatFilter);
      var subCat = [];
      var categoriesFilter = (0, _lodash.clone)(_this.state.categoriesFilter);
      if (subCatFilter[parentCode].indexOf(code) === -1) {
        subCat = (0, _lodash.union)(subCatFilter[parentCode], [String(code)]);
      } else {
        subCat = (0, _lodash.without)(subCatFilter[parentCode], String(code));
      }
      subCatFilter[parentCode] = subCat;
      var flag = false;
      for (var index = 0; index < _this.props.categories.length; index++) {
        if (_this.props.categories[index].code === parentCode) {
          if (_this.props.categories[index].childrens.length === subCat.length) {
            flag = true;
          }
        }
      }
      if (flag === true) {
        categoriesFilter[parentCode] = 'all';
      } else if (subCat.length > 0) {
        categoriesFilter[parentCode] = 'notAll';
      } else {
        categoriesFilter[parentCode] = 'none';
      }
      _this.props.handleSubCat(subCatFilter, categoriesFilter);
    }, _this.hanldeCheckedAddress = function (event) {
      _this.props.handleDistrictFilter(_this.props.addressFilter, String(event.target.name));
    }, _this.handleChangeSortType = function (event) {
      _this.props.changeSortType(event.target.value);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Discover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.loaded && this.props.loading !== true || !this.props.shops) {
        this.getResult.call(this);
      }
      var location = this.props.location;
      if (location && location.query && location.query.category) {
        this.initCategory.call(this, location);
      }
      document.addEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.addressFilter !== this.props.addressFilter) {
        this.setState({ addressFilter: nextProps.addressFilter });
      }
      if (nextProps.categoriesFilter !== this.props.categoriesFilter) {
        this.setState({ categoriesFilter: nextProps.categoriesFilter });
      }
      if (nextProps.subCatFilter !== this.props.subCatFilter) {
        this.setState({ subCatFilter: nextProps.subCatFilter });
      }
      if (nextProps.pageSize !== this.props.pageSize) {
        this.setState({ pageSize: nextProps.pageSize });
      }
      if (!nextProps.loading) {
        this.setState({ lazy: false });
      }
      if (nextProps.sort !== this.props.sort) {
        this.getResult(nextProps.sort);
      }
      if (nextProps && nextProps.location && this.props.location && nextProps.location.search !== this.props.location.search) {
        this.initCategory.call(this, nextProps.location);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.initCategory.call(this);
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'getResult',
    value: function getResult(nextPropsSort) {
      var filter = (0, _lib.processQuery)(this.state.query, this.props.province, this.props.addressFilter, this.props.categoriesFilter, this.props.subCatFilter, nextPropsSort ? nextPropsSort : this.props.sort, this.props.locationUser);
      this.props.getSearchResult(filter);
    }
  }, {
    key: 'isBottom',
    value: function isBottom(el) {
      return el.getBoundingClientRect().bottom <= window.innerHeight;
    }
  }, {
    key: 'initCategory',
    value: function initCategory(location) {
      var _this2 = this;

      var catLink = location && location.query && location.query.category.split(',') || [];
      this.setState({ cat: catLink[0] });
      var catCode = [];
      catLink.map(function (value) {
        for (var index = 0; index < _this2.props.categories.length; index++) {
          if (_this2.props.categories[index].link === value || _this2.props.categories[index].code === value) {
            // Tránh trường hợp code củ chạy không đúng
            catCode.push(_this2.props.categories[index].code);
          }
        }
      });
      var categoriesFilter = (0, _lodash.clone)(this.state.categoriesFilter);
      var subCatFilter = (0, _lodash.clone)(this.state.subCatFilter);
      for (var key in categoriesFilter) {
        if (categoriesFilter.hasOwnProperty(key)) {
          if (catCode.indexOf(key) !== -1) {
            categoriesFilter[key] = 'all';
            for (var index = 0; index < this.props.categories.length; index++) {
              if (this.props.categories[index].code === key) {
                var childrens = this.props.categories[index].childrens;
                for (var jndex = 0; jndex < childrens.length; jndex++) {
                  subCatFilter[key] = (0, _lodash.union)(subCatFilter[key], [String(childrens[jndex].code)]);
                }
              }
            }
          } else {
            categoriesFilter[key] = 'none';
            subCatFilter[key] = [];
          }
        }
      }
      this.props.handleMainCat(categoriesFilter, subCatFilter);
    }
  }, {
    key: 'collapseHandle',
    value: function collapseHandle(code) {
      var collapse = this.state.collapse;
      collapse[code] = !collapse[code];
      this.setState({ collapse: collapse });
    }
  }, {
    key: 'clearCatFilter',
    value: function clearCatFilter() {
      var subCatFilter = (0, _lodash.clone)(this.state.subCatFilter);
      var categoriesFilter = (0, _lodash.clone)(this.state.categoriesFilter);
      for (var index = 0; index < this.props.categories.length; index++) {
        categoriesFilter[this.props.categories[index].code] = 'none';
        subCatFilter[this.props.categories[index].code] = [];
      }
      this.props.handleSubCat(subCatFilter, categoriesFilter);
    }
  }, {
    key: 'clearAddressFilter',
    value: function clearAddressFilter() {
      this.props.handleDistrictFilter([], '');
    }
  }, {
    key: 'clearQuery',
    value: function clearQuery() {
      this.props.changeQuery('');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./Discover.scss');
      var _props = this.props,
          shops = _props.shops,
          categories = _props.categories,
          districts = _props.districts,
          query = _props.query,
          total = _props.total,
          sort = _props.sort,
          location = _props.location;
      var _state = this.state,
          collapse = _state.collapse,
          addressFilter = _state.addressFilter,
          subCatFilter = _state.subCatFilter,
          categoriesFilter = _state.categoriesFilter,
          lazy = _state.lazy,
          pageSize = _state.pageSize;

      var seoInfo = seoInfos && seoInfos[this.state.cat] ? seoInfos[this.state.cat] : null;
      var cards = [];
      var labelType = (0, _lib.paserType)(categories, categoriesFilter);
      var labelAddress = (0, _lib.paserAddress)(districts, addressFilter);
      if (shops && shops.length > 0) {
        var length = shops.length;
        for (var index = 0; index < length; index++) {
          cards.push(_react2.default.createElement(
            'div',
            { className: 'col-xs-6 col-md-4', key: String(index) },
            _react2.default.createElement(_components.ShopCard, { shop: shops[index] })
          ));
        }
      }
      // Left category
      var types = [];
      if (categories && categories.length > 0) {
        var _loop = function _loop(_index) {
          var subList = [];
          var code = categories[_index].code;
          var mainClass = collapse[code] ? styles.collapse : '';
          mainClass += categoriesFilter && categoriesFilter[code] === 'all' ? '' : ' ' + styles.notAll;
          if (categories[_index] && categories[_index].childrens && categories[_index].childrens.length > 0) {
            var childrens = categories[_index].childrens;
            var subArray = subCatFilter[code];
            for (var jndex = 0; jndex < childrens.length; jndex++) {
              var subCode = childrens[jndex].code;
              subList.push(_react2.default.createElement(
                'li',
                { key: String(_index + '-' + jndex) },
                subArray.indexOf(String(subCode)) !== -1 ? _react2.default.createElement('input', {
                  type: 'checkbox',
                  id: subCode + '_leftsubcat',
                  name: subCode,
                  onChange: _this3.handleChangeSubCat,
                  checked: true
                }) : _react2.default.createElement('input', {
                  type: 'checkbox',
                  id: subCode + '_leftsubcat',
                  name: subCode,
                  onChange: _this3.handleChangeSubCat
                }),
                _react2.default.createElement(
                  'label',
                  { htmlFor: subCode + '_leftsubcat' },
                  childrens[jndex].label
                )
              ));
            }
            types.push(_react2.default.createElement(
              'li',
              { key: String(_index), className: mainClass },
              categoriesFilter && categoriesFilter[code] !== 'none' ? _react2.default.createElement('input', {
                type: 'checkbox',
                id: code + '_leftcat',
                name: code,
                className: styles.mainCat,
                onChange: _this3.handleChangeMainCat,
                checked: true
              }) : _react2.default.createElement('input', {
                type: 'checkbox',
                id: code + '_leftcat',
                name: code,
                className: styles.mainCat,
                onChange: _this3.handleChangeMainCat
              }),
              _react2.default.createElement(
                'label',
                {
                  className: styles.labelMainCat,
                  htmlFor: code + '_leftcat'
                },
                categories[_index].label
              ),
              _react2.default.createElement(_reactBootstrap.Glyphicon, {
                onClick: function onClick() {
                  return _this3.collapseHandle(code);
                },
                className: styles.icon,
                glyph: collapse[code] ? 'plus' : 'minus'
              }),
              _react2.default.createElement(
                'ul',
                { className: styles.subList },
                subList
              )
            ));
          } else {
            types.push(_react2.default.createElement(
              'li',
              { key: String(_index), className: mainClass },
              categoriesFilter && categoriesFilter[code] !== 'none' ? _react2.default.createElement('input', {
                type: 'checkbox',
                id: code + '_leftcat',
                name: code,
                className: styles.mainCat,
                onChange: _this3.handleChangeMainCat,
                checked: true
              }) : _react2.default.createElement('input', {
                type: 'checkbox',
                id: code + '_leftcat',
                name: code,
                className: styles.mainCat,
                onChange: _this3.handleChangeMainCat
              }),
              _react2.default.createElement(
                'label',
                {
                  className: styles.labelMainCat,
                  htmlFor: code + '_leftcat'
                },
                categories[_index].label
              )
            ));
          }
        };

        for (var _index = 0; _index < categories.length; _index++) {
          _loop(_index);
        }
      }
      // Left Area
      var areas = [];
      if (districts && districts.length > 0) {
        for (var _index2 = 0; _index2 < districts.length; _index2++) {
          var _code = districts[_index2].code;
          areas.push(_react2.default.createElement(
            'li',
            { key: String(_index2) },
            addressFilter.indexOf(String(_code)) !== -1 ? _react2.default.createElement('input', {
              type: 'checkbox',
              ref: 'addressFilter',
              id: _code,
              name: _code,
              onChange: this.hanldeCheckedAddress,
              checked: true
            }) : _react2.default.createElement('input', {
              type: 'checkbox',
              ref: 'addressFilter',
              id: _code,
              name: _code,
              onChange: this.hanldeCheckedAddress
            }),
            _react2.default.createElement(
              'label',
              { htmlFor: _code },
              (0, _lib.typeAreaAbbreviation)(districts[_index2].type) + districts[_index2].name
            )
          ));
        }
      }
      var url = location ? _config2.default.siteUrl + location.pathname : _config2.default.siteUrl;
      return _react2.default.createElement(
        'div',
        { className: styles.discover },
        _react2.default.createElement(_reactHelmet2.default, {
          title: seoInfo && seoInfo.title ? seoInfo.title : 'Discover',
          meta: [{
            name: 'description',
            property: 'og:description',
            content: seoInfo && seoInfo.description ? seoInfo.description : ''
          }, { property: 'og:type', content: '' }, {
            property: 'og:title',
            content: seoInfo && seoInfo.title ? seoInfo.title : 'Discover'
          }, {
            property: 'og:image',
            content: seoInfo && seoInfo.image ? seoInfo.image : ''
          }, { property: 'og:url', content: url }]
        }),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { md: 3 },
              _react2.default.createElement(
                'div',
                { className: styles.leftContainer },
                _react2.default.createElement(
                  'div',
                  { className: styles.types },
                  _react2.default.createElement(
                    'div',
                    { className: styles.titleTypes },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'tasks' }),
                    'Lo\u1EA1i H\xECnh'
                  ),
                  _react2.default.createElement(
                    'ol',
                    { className: styles.mainList },
                    types
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.area },
                  _react2.default.createElement(
                    'div',
                    { className: styles.titleTypes },
                    _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'map-marker' }),
                    'Khu v\u1EF1c'
                  ),
                  _react2.default.createElement(
                    'ul',
                    { className: styles.subList },
                    areas
                  )
                )
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { md: 9 },
              _react2.default.createElement(
                'div',
                { className: styles.rightContainer },
                _react2.default.createElement(
                  'div',
                  { className: styles.headContent },
                  _react2.default.createElement(
                    'div',
                    { className: styles.topHeader },
                    _react2.default.createElement(
                      'div',
                      { className: styles.leftTab },
                      _react2.default.createElement(
                        'div',
                        { className: styles.tab + ' ' + styles.activeTab },
                        '\u0110\u1ECBa \u0111i\u1EC3m'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.rightTab },
                      _react2.default.createElement(
                        'div',
                        { className: styles.numberShop },
                        _react2.default.createElement(
                          'span',
                          { className: styles.number },
                          total || 0
                        ),
                        ' \u0111\u1ECBa \u0111i\u1EC3m'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: styles.order },
                        _react2.default.createElement(
                          'label',
                          { htmlFor: 'order' },
                          'S\u1EAFp x\u1EBFp'
                        ),
                        _react2.default.createElement(
                          'select',
                          {
                            name: 'order',
                            id: 'order',
                            className: styles.select + ' ' + styles.minimal,
                            value: sort,
                            onChange: function onChange(event) {
                              return _this3.handleChangeSortType(event);
                            }
                          },
                          _react2.default.createElement(
                            'option',
                            { value: 'prominent' },
                            '\u0110\u1ECBa \u0111i\u1EC3m n\u1ED5i b\u1EADt'
                          ),
                          _react2.default.createElement(
                            'option',
                            { value: 'near' },
                            'G\u1EA7n t\xF4i nh\u1EA5t'
                          ),
                          _react2.default.createElement(
                            'option',
                            { value: 'total_like' },
                            'Nhi\u1EC1u like nh\u1EA5t'
                          ),
                          _react2.default.createElement(
                            'option',
                            { value: 'total_view' },
                            'Nhi\u1EC1u view nh\u1EA5t'
                          ),
                          _react2.default.createElement(
                            'option',
                            { value: 'total_review' },
                            'Nhi\u1EC1u b\xECnh lu\u1EADn nh\u1EA5t'
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.bottomHeader },
                    query && _react2.default.createElement(
                      'div',
                      { className: styles.itemFilter },
                      'T\u1EEB kh\xF3a',
                      ' ',
                      _react2.default.createElement(
                        'span',
                        { className: styles.valueFilter },
                        query
                      ),
                      _react2.default.createElement('i', {
                        className: 'fa fa-times ' + styles.icon,
                        'aria-hidden': 'true',
                        onClick: function onClick() {
                          return _this3.clearQuery();
                        }
                      })
                    ),
                    labelType && labelType.length > 0 && _react2.default.createElement(
                      'div',
                      { className: styles.itemFilter },
                      'Lo\u1EA1i h\xECnh',
                      ' ',
                      _react2.default.createElement(
                        'span',
                        { className: styles.valueFilter },
                        labelType.join(', ')
                      ),
                      _react2.default.createElement('i', {
                        className: 'fa fa-times ' + styles.icon,
                        'aria-hidden': 'true',
                        onClick: function onClick() {
                          return _this3.clearCatFilter();
                        }
                      })
                    ),
                    labelAddress && labelAddress.length > 0 && _react2.default.createElement(
                      'div',
                      { className: styles.itemFilter },
                      'Khu v\u1EF1c',
                      ' ',
                      _react2.default.createElement(
                        'span',
                        { className: styles.valueFilter },
                        addressFilter.length === districts.length ? 'all' : labelAddress.join(', ')
                      ),
                      _react2.default.createElement('i', {
                        className: 'fa fa-times ' + styles.icon,
                        'aria-hidden': 'true',
                        onClick: function onClick() {
                          return _this3.clearAddressFilter();
                        }
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactBootstrap.Row,
                  { className: styles.bodyContent, id: 'bodyContent' },
                  shops && shops.length > 0 ? cards : _react2.default.createElement(
                    'p',
                    { className: styles.noResult },
                    'Kh\xF4ng t\xECm th\u1EA5y k\u1EBFt qu\u1EA3 ph\xF9 h\u1EE3p.'
                  )
                ),
                _react2.default.createElement(
                  _reactBootstrap.Row,
                  null,
                  pageSize <= total && lazy ? _react2.default.createElement('div', { className: styles.lazyLoad }) : _react2.default.createElement(
                    'p',
                    { className: styles.endResult },
                    '----- End Results -----'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Discover;
}(_react.Component), _class2.propTypes = {
  addressFilter: _react.PropTypes.array,
  categories: _react.PropTypes.array,
  categoriesFilter: _react.PropTypes.object,
  changeQuery: _react.PropTypes.func.isRequired,
  changeSortType: _react.PropTypes.func,
  districts: _react.PropTypes.array,
  getSearchResult: _react.PropTypes.func.isRequired,
  handleDistrictFilter: _react.PropTypes.func.isRequired,
  handleMainCat: _react.PropTypes.func.isRequired,
  handleSubCat: _react.PropTypes.func.isRequired,
  load: _react.PropTypes.func.isRequired,
  loaded: _react.PropTypes.bool,
  loading: _react.PropTypes.bool,
  location: _react.PropTypes.object,
  locationUser: _react.PropTypes.object,
  pageSize: _react.PropTypes.number,
  province: _react.PropTypes.string,
  query: _react.PropTypes.string,
  shops: _react.PropTypes.array,
  sort: _react.PropTypes.string,
  subCatFilter: _react.PropTypes.object,
  total: _react.PropTypes.number
}, _temp2)) || _class) || _class);
exports.default = Discover;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Discover/Discover.js
// module id = 1674
// module chunks = 0